import { render, staticRenderFns } from "./NInput.vue?vue&type=template&id=20cacc4d"
import script from "./NInput.vue?vue&type=script&lang=js"
export * from "./NInput.vue?vue&type=script&lang=js"
import style0 from "./NInput.vue?vue&type=style&index=0&id=20cacc4d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports